import { defaultTo } from '../../utils/fp';
import dataflowParser from './dataflowParser';
import facetsParser from './facetsParser';

export default options => data => ({
  dataflows: data.dataflows.map(dataflowParser({ highlighting: data.highlighting })),
  facets: facetsParser(options)(data.facets),
  searchResultNb: defaultTo(0, data.numFound),
});
